// extracted by mini-css-extract-plugin
export default {"discloseInfoTextLabel":"styles__discloseInfoTextLabel___3idy2"};